import React from "react";
import "./Logo.css";


export const Logo = () => {
  return (
    <span 
      className='logo'
      aria-label="Step to Travel" 
      lang="en" 
      translate="no"
      role="img" 
    >
      <span className='primary'>Stepto</span>
      <span className='accent'>TRAVEL</span>
    </span>
  );
};
